import Vue from 'vue'
import VueRouter from 'vue-router'
import { fb_auth, fb_users } from '../firebase'

//Public Routes
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Signup from '../views/Signup.vue'
import Forgot from '../views/Forgot.vue'


//Private Routes
import Layout from '../views/Layout.vue'
import PMCS from '../views/PMCS.vue'
import Dispatch from '../views/Dispatch.vue'
import Appointment from '../views/Appointment.vue'
import Profile from '../views/UserProfile.vue'
import OperatorFaults from '../views/OperatorFaults.vue'
import Survey from '../views/Survey.vue'
import AwaitingApproval from '../views/AwaitingApproval.vue'
import FaultsEditOperator from '../views/FaultsEditOperator.vue'
import LeadDashboard from '../views/LeadDashboard.vue'
import MyUnitsFaults from '../views/MyUnitsFaults.vue'


//Private Routes (Maintenance Manager/Mechanic/Tool Room Manager)
import NewFaults from '../views/NewFaults.vue'
import VerifiedFaults from '../views/VerifiedFaults.vue'
import PartsRequest from '../views/PartsRequest.vue'
import ClerkNewPartsReq from '../views/ClerkNewPartsReq.vue'
import UsersEdit from '../views/UsersEdit.vue'
import Users from '../views/Users.vue'
import FaultsEditMM from '../views/FaultsEditMM.vue'
import FaultsEditMech from '../views/FaultsEditMech.vue'
import ManHours from '../views/ManHours.vue'
import PartsRequestForFault from '../views/PartsRequestForFault.vue'
import Assigned from '../views/Assigned.vue'
import Upload from '../views/Upload.vue'
import FaultsWorkbench from '../views/FaultsWorkbench.vue'
import ToolRoom from '../views/ToolRoom.vue'
import SmartFacility from '../views/SmartFacility.vue'
import MMISManager from '../views/MMISManager.vue'

//Private Routes (Clerk)
import ClerksNewDispatch from '../views/ClerksNewDispatch.vue'
import ClerksNewFaults from '../views/ClerksNewFaults.vue'















Vue.use(VueRouter)

  const routes = [
  //Public routes
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
  },
  {
    path: '/forgotpassword',
    name: 'Forgot',
    component: Forgot,
  },
  // Private routes are children of the Layout component
  {
    path: '/layout',
    name: 'Layout',
    component: Layout,
    meta: {
      authReq: true
    },
    children: [
      {
        path: '/survey',
        name: 'Survey',
        component: Survey,
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/awaitingapproval',
        name: 'Awaiting Approval',
        component: AwaitingApproval,
      },
      {
        path: '/pmcs',
        name: 'PMCS',
        component: () => import('../views/PMCS.vue'),
      },
      {
        path: '/dispatch',
        name: 'Dispatch',
        component: () => import('../views/Dispatch.vue'),
      },
      {
        path: '/appointment',
        name: 'Appointment',
        component: () => import('../views/Appointment.vue'),
      },
      
      {
        path: '/assigned',
        name: 'Assigned',
        component: () => import('../views/Assigned.vue'),
        // component: () => import(/* webpackChunkName: "admin" */ '../views/Assigned.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager'
          ]
        }
      },

      {
        path: '/myfaults',
        name: 'OperatorFaults',
        component: () => import('../views/OperatorFaults.vue'),
      },

      {
        path: '/leaddashboard',
        name: 'Org Lead',
        component: () => import('../views/LeadDashboard.vue'),
        meta :{
          requiresRole: [
            'Org. Leader',
            'Maint. Manager',
            
          ]
        }
      },
      {
        path: '/myunitsfaults',
        name: 'MyUnitsFaults',
        component: () => import('../views/MyUnitsFaults.vue'),
        meta :{
          requiresRole: [
            'Org. Leader',
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/upload',
        name: 'Upload',
        component: () => import('../views/Upload.vue'),
        meta :{
          requiresRole: [
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue'),
      },
      {
        path: '/newfaults',
        name: 'NewFaults',
        component: () => import('../views/NewFaults.vue'),
        meta :{
          requiresRole: [
            'Maint. Manager',
          ]
        }
      },
      {
        path: '/verifiedfaults',
        name: 'VerifiedFaults',
        component: () => import('../views/VerifiedFaults.vue'),
        meta :{
          requiresRole: [
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/newpartsreq',
        name: 'ClerkNewPartsReq',
        component: () => import('../views/ClerkNewPartsReq.vue'),
        meta :{
          requiresRole: [
            'Clerk',

          ]
        }
      },
      {
        path: '/partsrequest',
        name: 'PartsRequest',
        component: () => import('../views/PartsRequest.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/mech/orderparts/:id',
        name: 'PartsRequestForFault',
        component: () => import('../views/PartsRequestForFault.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
          ]
        }
      },
      {
        path: '/users/:id',
        name: 'UsersEdit',
        component: () => import('../views/UsersEdit.vue'),
        meta :{
          requiresRole: [
            'Maint. Manager',
          ]
        }
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import('../views/Users.vue'),
        meta :{
          requiresRole: [
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/mm/fault/:id',
        name: 'FaultsEditMM',
        component: () => import('../views/FaultsEditMM.vue'),
        meta :{
          requiresRole: [
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/mech/fault/:id',
        name: 'FaultsEditMech',
        component: () => import('../views/FaultsEditMech.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager',
          ]
        }
      },
      {
        path: '/myfaults/:id',
        name: 'FaultsEditOperator',
        component: () => import('../views/FaultsEditOperator.vue'),
      },
      {
        path: '/manhours',
        name: 'ManHours',
        component: () => import('../views/ManHours.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/addtogcss',
        name: 'ClerksNewFaults',
        component: () => import('../views/ClerksNewFaults.vue'),
        meta :{
          requiresRole: [
            'Clerk',

          ]
        }
      },
      {
        path: '/newdispatch',
        name: 'ClerksNewDispatch',
        component: () => import('../views/ClerksNewDispatch.vue'),
        meta :{
          requiresRole: [
            'Clerk',
          ]
        }
      },
      {
        path: '/faultsworkbench',
        name: 'FaultsWorkbench',
        component: () => import('../views/FaultsWorkbench.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/toolroom',
        name: 'ToolRoom',
        component: () => import('../views/ToolRoom.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/smartfacility',
        name: 'SmartFacility',
        component: () => import('../views/SmartFacility.vue'),
        meta :{
          requiresRole: [
            'Mechanic',
            'Maint. Manager'
          ]
        }
      },
      {
        path: '/mmismanager',
        name: 'MMISManager',
        component: () => import('../views/MMISManager.vue'),
        meta :{
          requiresRole: [
            'Maint. Manager',
          ]
        }
      },

    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  const authReq = to.matched.some(x => x.meta.authReq)
  if (authReq) {
    fb_auth.onAuthStateChanged(async user => {
      if (user) {  
      let userRef = await fb_users.doc(user.uid).get()
      let userData = userRef.data()
        //user is logegd in
        if (to.meta.requiresRole) {
          console.debug('A specific role is required for this route.')
          // roll required
          to.meta.requiresRole.forEach(reqRole => {
            if (userData.role == reqRole) {
              console.debug('User\'s role is sufficent.')
              next()
            } 
          });
        } else {
          next()
        }
      } else {
        next('/login')
      }
    })
  } else {
    next()
  }
})


export default router
